export default __webpack_public_path__ + "static/media/logo-ecos.1b6c4782.svg";